import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { randomPurchase, type PurchaseEvent } from '../data/socialProof';
const VISIBLE_MS = 5500;
const MIN_GAP_MS = 40000;
const MAX_GAP_MS = 60000;
/** Cantidad total de avisos que se muestran por visita */
const MAX_SHOWS = 2;
const nextGap = () => MIN_GAP_MS + Math.random() * (MAX_GAP_MS - MIN_GAP_MS);
export function PurchaseProof() {
  const [purchase, setPurchase] = useState<PurchaseEvent | null>(null);
  const [dismissed, setDismissed] = useState<boolean>(false);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed) return;
    const clearTimers = () => {
      timers.current.forEach(id => window.clearTimeout(id));
      timers.current = [];
    };
    let shown = 0;
    const schedule = (delay: number) => {
      const showId = window.setTimeout(() => {
        setPurchase(randomPurchase());
        shown += 1;
        const hideId = window.setTimeout(() => {
          setPurchase(null);
          if (shown < MAX_SHOWS) schedule(nextGap());
        }, VISIBLE_MS);
        timers.current.push(hideId);
      }, delay);
      timers.current.push(showId);
    };
    schedule(9000);
    return clearTimers;
  }, [dismissed]);
  const handleDismiss = () => {
    setPurchase(null);
    setDismissed(true);
  };
  return <AnimatePresence data-id="element-212" data-mp="1n2ak65fufpum">
      {purchase ? <motion.aside key={`${purchase.name}-${purchase.offer}`} initial={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.98
    }} transition={{
      duration: 0.28,
      ease: [0.23, 1, 0.32, 1]
    }} aria-live="polite" className="fixed bottom-4 left-3 right-3 z-30 sm:bottom-5 sm:left-5 sm:right-auto sm:w-[22rem]" data-id="element-213" data-mp="1n56k1zb94olp">
          <div className="flex items-start gap-3 rounded-2xl bg-cream-50 p-3 shadow-lift ring-1 ring-teal-900/10" data-id="element-214" data-mp="3swtrfr1sz4rv">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal-700" data-id="element-215" data-mp="1wtxeg7qgs1v5">
              <BadgeCheckIcon className="h-5 w-5 text-cream-50" aria-hidden="true" data-id="element-216" data-mp="21srx99oflqf9" />
            </span>

            <div className="min-w-0 flex-1" data-id="element-217" data-mp="26pia7o4xw5wg">
              <p className="font-display text-[0.65rem] font-800 uppercase tracking-[0.14em] text-teal-600" data-id="element-218" data-mp="2asoq7nhutbg4">
                Compra verificada
              </p>
              <p className="mt-0.5 truncate font-display text-sm font-700 text-teal-900" data-id="element-219" data-mp="2fr8aljgsuf6d">
                {purchase.name}
                <span className="ml-1.5 inline-flex items-center gap-1 align-middle text-[0.7rem] font-500 text-clay" data-id="element-220" data-mp="2kohyguojiis3">
                  <MapPinIcon className="h-3 w-3" aria-hidden="true" data-id="element-221" data-mp="2uge8n43whzco" />
                  {purchase.city}
                </span>
              </p>
              <p className="mt-0.5 text-[0.7rem] leading-snug text-ink/70" data-id="element-222" data-mp="2yjkg2f2r1wkq">
                Acaba de comprar: {purchase.offer}
              </p>
            </div>

            <button type="button" onClick={handleDismiss} aria-label="Cerrar aviso de compra" className="-mr-0.5 -mt-0.5 rounded-full p-1 text-clay transition-colors duration-150 ease-out hover:text-teal-900" data-id="element-223" data-mp="ruiddfcf2l06">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-224" data-mp="du7micb3x6f0" />
            </button>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}